import { SimplePage } from "@/app/_/marketing/SimplePage";
import { Navigation } from "@/constants";

export default function Page() {
  return (
    <SimplePage
      eyebrow="Contact"
      title="Let's talk."
      subtitle="Partnerships, press, support, or a question about the product — drop us a line and we'll get back to you."
      primaryCta={{
        label: "Join waitlist",
        to: Navigation.ROUTES.AUTH.WAITLIST,
      }}
    />
  );
}
